import request from '@/services/interceptor.js'

// Elenco ordini
export const get_elenco = () => {
    return request({
        url: '/misure',
        method: 'get',
        loadingBar: true
    })
}

// Dettaglio ordine
export const get_ordine = (id) => {
    return request({
        url: `/misure/${id}`,
        method: 'get',
        loadingBar: true
    })
}

export const get_numero_ordine = () => {
    return request({
        url: `/misure/numero`,
        method: 'get',
        loadingBar: true
    })
}

// Crea ordine
export const crea_ordine = (dati) => {
    return request({
        url: '/misure',
        method: 'post',
        data: dati,
        loadingBar: true
    })
}

// Modifica ordine
export const modifica_ordine = (id, dati) => {
    return request({
        url: `/misure/${id}`,
        method: 'put',
        data: dati,
        loadingBar: true
    })
}

// Elimina ordine
export const elimina_ordine = (id) => {
    return request({
        url: `/misure/${id}`,
        method: 'delete',
        loadingBar: true
    })
}

// Crea riga misura
export const crea_riga_misura = (ordineId, dati) => {
    return request({
        url: `/misure/${ordineId}/righe`,
        method: 'post',
        data: dati,
        loadingBar: true
    })
}

// Modifica riga misura
export const modifica_riga_misura = (ordineId, rigaId, dati) => {
    return request({
        url: `/misure/${ordineId}/righe/${rigaId}`,
        method: 'put',
        data: dati,
        loadingBar: true
    })
}

// Elimina riga misura
export const elimina_riga_misura = (ordineId, rigaId) => {
    return request({
        url: `/misure/${ordineId}/righe/${rigaId}`,
        method: 'delete',
        loadingBar: true
    })
}

// Carica allegato
export const carica_allegato = (ordineId, file) => {
    const formData = new FormData()
    formData.append('file', file)

    return request({
        url: `/misure/${ordineId}/allegati`,
        method: 'post',
        data: formData,
        headers: {
            'Content-Type': 'multipart/form-data'
        },
        loadingBar: true
    })
}

// Scarica allegato
export const scarica_allegato = (ordineId, allegatoId) => {
    return request({
        url: `/misure/${ordineId}/allegati/${allegatoId}`,
        method: 'get',
        responseType: 'blob',
        loadingBar: true
    })
}

// Elimina allegato
export const elimina_allegato = (ordineId, allegatoId) => {
    return request({
        url: `/misure/${ordineId}/allegati/${allegatoId}`,
        method: 'delete',
        loadingBar: true
    })
}

export const elenco_allegati = (ordineId,) => {
    return request({
        url: `/misure/allegati/elenco/${ordineId}`,
        method: 'get',
        loadingBar: true
    })
}

// Salva firma
export const salva_firma = (ordineId, firmaBlob) => {
    const formData = new FormData()
    formData.append('firma', firmaBlob, 'firma.png')

    return request({
        url: `/misure/${ordineId}/firma`,
        method: 'post',
        data: formData,
        headers: {
            'Content-Type': 'multipart/form-data'
        },
        loadingBar: true
    })
}


//  Tipo commessa (deve corrispondere all'enum TipoCommessaExport nel backend):
//    0 = Rilievo (default)
//    1 = Persiana
//    2 = PortaInterna
// ─────────────────────────────────────────────────────────────────────────────

// Esporta commessa in Excel e la scarica direttamente nel browser
export const esporta_commessa_excel = (id, tipo = 0) => {
    return request({
        url: `/misure/${id}/export`,
        method: 'get',
        params: tipo !== 0 ? { tipo } : {},
        responseType: 'blob',
        loadingBar: true
    })
}

// Esporta commessa in PDF e la scarica direttamente nel browser
export const esporta_commessa_pdf = (id, tipo = 0) => {
    return request({
        url: `/misure/${id}/export`,
        method: 'get',
        params: { formato: 'pdf', ...(tipo !== 0 ? { tipo } : {}) },
        responseType: 'blob',
        loadingBar: true
    })
}